// src/app/pages/boutique-page/boutique-page.component.ts
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

interface ShopService {
  name: string;
  price: number;
  currency: string;
  summary: string;
  detail: string;
  delivery: string;
}

interface ShopCategory {
  title: string;
  icon: string;
  services: ShopService[];
}

@Component({
  selector: 'app-boutique-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './boutique-page.component.html',
  styleUrls: ['./boutique-page.component.scss']
})
export class BoutiquePageComponent {
  // Contenu statique pour l'instant : les boutons "Ajouter" ne font que
  // marquer un service comme sélectionné localement (pas de panier/devis réel).
  categories: ShopCategory[] = [
    {
      title: 'Audio & musique',
      icon: 'fa-music',
      services: [
        {
          name: 'Mix Basique',
          price: 150,
          currency: 'CHF',
          summary: 'Mix stéréo, 2 révisions',
          detail: 'Mixage professionnel de votre morceau en stéréo, avec égalisation, compression et balance des niveaux. Inclut 2 allers-retours de révision.',
          delivery: '3-5 jours'
        },
        {
          name: 'Mastering Basique',
          price: 50,
          currency: 'CHF',
          summary: 'Mastering stéréo',
          detail: 'Mastering stéréo de votre mix pour un rendu prêt à la diffusion (streaming, radio), avec ajustement du volume, de la dynamique et de la tonalité.',
          delivery: '1-2 jours'
        },
        {
          name: 'Beat Lease',
          price: 30,
          currency: 'CHF',
          summary: 'License MP3/WAV',
          detail: 'Licence non exclusive d\'utilisation du beat au format MP3/WAV, idéale pour les projets indépendants.',
          delivery: 'Immédiat'
        },
        {
          name: 'Mix Standard',
          price: 290,
          currency: 'CHF',
          summary: 'Mix + mastering léger',
          detail: 'Mixage complet de votre morceau accompagné d\'un mastering léger pour un rendu homogène, prêt pour la diffusion.',
          delivery: '5-7 jours'
        },
        {
          name: 'Mastering Standard',
          price: 90,
          currency: 'CHF',
          summary: 'Mastering + stems',
          detail: 'Mastering stéréo avec livraison des stems (pistes séparées) en plus du fichier final, pour plus de flexibilité.',
          delivery: '2-3 jours'
        },
        {
          name: 'Beat Exclusive',
          price: 150,
          currency: 'CHF',
          summary: 'License exclusive + stems',
          detail: 'Licence exclusive : le beat est retiré de la vente et vous en devenez l\'unique utilisateur. Livré avec les stems séparés.',
          delivery: 'Immédiat'
        },
        {
          name: 'Mix Premium',
          price: 490,
          currency: 'CHF',
          summary: 'Mix professionnel complet',
          detail: 'Mixage professionnel complet multi-pistes avec traitement avancé, automations détaillées et révisions jusqu\'à validation.',
          delivery: '7-10 jours'
        },
        {
          name: 'Mastering Album',
          price: 290,
          currency: 'CHF',
          summary: 'Album complet (10 tracks)',
          detail: 'Mastering cohérent pour un album complet (jusqu\'à 10 titres), avec homogénéisation du volume et de la tonalité entre les morceaux.',
          delivery: '5-7 jours'
        },
        {
          name: 'Production Custom',
          price: 390,
          currency: 'CHF',
          summary: 'Beat sur mesure',
          detail: 'Création d\'un beat original sur mesure selon vos directives (style, ambiance, tempo), avec échanges et ajustements inclus.',
          delivery: '3-7 jours'
        }
      ]
    }
  ];

  expandedService: string | null = null;
  private selected = new Set<string>();

  toggleDetails(serviceName: string): void {
    this.expandedService = this.expandedService === serviceName ? null : serviceName;
  }

  toggleSelect(service: ShopService): void {
    if (this.selected.has(service.name)) {
      this.selected.delete(service.name);
    } else {
      this.selected.add(service.name);
    }
  }

  isSelected(serviceName: string): boolean {
    return this.selected.has(serviceName);
  }

  get selectedCount(): number {
    return this.selected.size;
  }

  get selectedTotal(): number {
    return this.categories
      .flatMap(c => c.services)
      .filter(s => this.selected.has(s.name))
      .reduce((sum, s) => sum + s.price, 0);
  }
}
